"use client";
import { Button } from "@/app/components/ui/button";
import { Input } from "@/app/components/ui/input";
import { emailAddressSchema } from "@/lib/schemas/validationSchemas";
import { zodResolver } from "@hookform/resolvers/zod";
import { Flex, Text } from "@radix-ui/themes";
import axios, { HttpStatusCode } from "axios";
import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";
import { Dispatch, SetStateAction, useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Loader2 } from 'lucide-react';

type ForgotEmailForm = z.infer<typeof emailAddressSchema>;
interface Props {
  setForgot: Dispatch<SetStateAction<boolean>>;
  loggingIn: boolean;
  setLoggingIn: Dispatch<SetStateAction<boolean>>;
  router: AppRouterInstance;
  redirect?: Boolean;
  onComplete?: any;
}

const ForgotPassword = ({
  setForgot,
  loggingIn,
  setLoggingIn,
  router,
  redirect = true,
  onComplete = () => { },
}: Props) => {
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm<ForgotEmailForm>({ resolver: zodResolver(emailAddressSchema) });
  const [error, setError] = useState("");
  const [emailSent, setEmailSent] = useState(false);

  async function handleSendPasswordResetRequest(formData: ForgotEmailForm) {
    setLoggingIn(true);
    try {
      const res = await axios.post("/api/forgot", formData);
      if (res.status !== HttpStatusCode.Ok) {
        throw Error(res.data.error || "Forgot Password Form Error");
      } else {
        if (redirect) {
          router.push(`/password/send?email=${formData.email}`);
        } else {
          setEmailSent(true);
        }
      }
    } catch (error: any) {
      setLoggingIn(false);
      setError(
        error.response.data.error ||
        "An error occurred. Please contact support."
      );
    }
  }

  if (emailSent) {
    return (
      <Flex
        justify={"end"}
        align={"center"}
        direction={"column"}
        className="gap-8"
      >
        <Text className="text-base">
          A password reset request has been sent to {getValues("email")}
          .
        </Text>
        <Button
          className="w-full"
          onClick={() => {
            if (onComplete) onComplete();
          }}
        >
          Close
        </Button>
      </Flex>
    );
  }

  return (
    <Flex
      direction={"column"}
      align={"center"}
      width="100%"
      gap="2"
    >
      <form
        onSubmit={handleSubmit(handleSendPasswordResetRequest)}
        className="flex flex-col w-full gap-6"
      >
        <Flex direction={"column"} gap="2">
          {/* <Flex
            direction={"column"}
            align={"center"}
            justify={"between"}
            className="min-h-12"
          > */}
            {/* <Text className="text-2xl font-semibold text-black">
              Forgot Password?
            </Text>
            <Text color="gray">
              Please enter your email to receive password reset instructions.{" "}
            </Text> */}
          {/* </Flex> */}
          <Flex direction="column">
            <Input
              disabled={loggingIn}
              placeholder="Email"
              className="h-12 rounded-md mt-4"
              type="email"
              required={true}
              {...register("email")}
              onChange={(e) => {
                setError('');
                register("email").onChange(e);
              }}
            />
            {error &&
              <p className="text-red-600 leading-5">
                {error}
              </p>
            }
          </Flex>
        </Flex>
        <Flex width={"100%"}>
          <Button
            disabled={loggingIn}
            type="submit"
            className={"color-inverting-button-base h-12 hover:bg-white w-full"}
          >
            {loggingIn ? (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            ) : (
              "Reset Password"
            )}
          </Button>
        </Flex>
      </form >
      <Button
        disabled={loggingIn}
        onClick={() => setForgot(false)}
        className="w-full h-12 text-slate-900  bg-white hover:bg-slate-100 gap-2 mt-2"
      >
        <span style={{ fontSize: 18 }} className="material-icons">
          arrow_back
        </span>
        <Text>Back to Sign In</Text>
      </Button>
    </Flex >
  );
};

export default ForgotPassword;
